// Mock data for UNWP landing page

export const testimonials = [
  {
    id: 1,
    role: "Wedding Guest",
    content: "I gave my best friend a wedding gift through UNWP and she cried tears of joy. The photos and video message made it so much more than just a gift card - it was a memory she'll treasure forever.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    role: "Son & Caregiver",
    content: "For my mom's 60th birthday, I created an experience with photos from her childhood through today. She watched it three times in a row and called everyone to share it. Worth every penny.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    role: "Corporate HR Manager",
    content: "We used UNWP for our top performers' bonuses. The personalized video from our CEO plus their favorite gift cards made them feel truly valued. Employee retention has never been better.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Do I need a gift card to send a UNWP?",
    answer: "No — a gift card is completely optional. At its heart, a UNWP is your photos, videos and words wrapped in a mystery countdown reveal. That's the gift. If you'd like to add a gift card too, you can use ANY gift card from ANY retailer — Amazon, Starbucks, Woolworths, or your local boutique — but you never have to."
  },
  {
    id: 2,
    question: "How does the anonymous countdown reveal work?",
    answer: "Your surprise arrives as a mystery: a ticking countdown, your photos and videos locked behind it, and just a hint about who it's from. Group chats light up, everyone guesses, and when the timer hits zero the reveal opens itself — your story, your face, and a gift card if you chose to add one. Prefer no mystery? You can sign it from the start too."
  },
  {
    id: 3,
    question: "What does the recipient actually receive?",
    answer: "Recipients receive a notification via email or SMS. They'll see a countdown timer (if future-dated) and then click through to view your personalized story with all the photos, videos, and messages you've created. After experiencing the emotional journey, they can claim a gift card at the end — if you included one."
  },
  {
    id: 4,
    question: "Do I find out when they open it?",
    answer: "Yes — the moment the Time Vault opens and they experience your story, you're notified instantly. It's the shared payoff: while they're gasping at the reveal, you feel the same rush of excitement from wherever you are. The anticipation builds for both of you, and the joy lands together."
  },
  {
    id: 5,
    question: "When will UNWP launch?",
    answer: "We're launching in the next 60 days. The first 500 waitlist members will receive exclusive benefits including special promotions and priority access to all features."
  },
  {
    id: 6,
    question: "Is an anonymous gift really safe?",
    answer: "Yes. Every sender is verified through their payment method before anything is sent, and the reveal opens itself — there's nothing to click, no login, no app to install. You can't be phished by a gift that asks nothing of you."
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    phase: "You create",
    title: "Add Your Story",
    description: "Upload the photos, videos and heartfelt words that make it personal. This is the real gift.",
    icon: "Images"
  },
  {
    id: 2,
    phase: "You create",
    title: "Add a Gift Card (Optional)",
    description: "Want to? Attach a gift card from any retailer — or don't. The story stands on its own.",
    icon: "ShoppingBag"
  },
  {
    id: 3,
    phase: "You create",
    title: "Lock the Time Vault",
    description: "Set the perfect reveal time, drop a teasing hint and seal it in the Time Vault — your name stays a mystery until it opens.",
    icon: "Lock"
  },
  {
    id: 4,
    phase: "They unwrap",
    title: "The Guessing Begins",
    description: "A countdown, a hint, and a group chat asking: OK, which one of you is it?",
    icon: "Hourglass"
  },
  {
    id: 5,
    phase: "They unwrap",
    title: "The Vault Opens Itself",
    description: "The timer hits zero and the story unlocks — photos, video, message, and the gift card if you added one.",
    icon: "Sparkles"
  },
  {
    id: 6,
    phase: "You both feel it",
    title: "You Get the Moment Too",
    description: "The instant they open the Time Vault, you're notified — so you share the rush of the reveal from wherever you are, and watch the story get passed on.",
    icon: "Bell"
  }
];

export const stats = [
  {
    value: "92%",
    label: "Prefer Experiences"
  },
  {
    value: "41%",
    label: "Gift Card Value Wasted"
  },
  {
    value: "100%",
    label: "Memory Preserved"
  },
  {
    value: "500+",
    label: "Early Access Spots"
  }
];

export const weddingFeatures = [
  {
    title: "Perfect for Wedding Gifts",
    description: "Transform traditional cash gifts or gift cards into emotional experiences that celebrate the couple's journey."
  },
  {
    title: "Group Contributions Made Easy",
    description: "Multiple guests can contribute to one gift, each adding their own photos and messages."
  },
  {
    title: "Wedding Planner Partnership",
    description: "We would love the opportunity to partner with wedding planners to create the most memorable experiences for your clients."
  }
];